import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Target, Trophy } from 'lucide-react';

// Visual monthly-target progress meter for SE / DEO / RO dashboards.
// Silent when no target is configured — admins set it via User Management.
export default function TargetProgress({ target = 0, current = 0, testId = 'target-progress' }) {
  if (!target || target <= 0) return null;
  const percentRaw = (current / target) * 100;
  const percent = Math.min(percentRaw, 100);
  const complete = percentRaw >= 100;
  const colorClass = complete
    ? 'text-emerald-400'
    : percent >= 66
      ? 'text-emerald-400'
      : percent >= 33
        ? 'text-amber-400'
        : 'text-red-400';

  return (
    <Card className="bg-slate-900 border-slate-800" data-testid={testId}>
      <CardContent className="pt-5 pb-5">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            {complete
              ? <Trophy className="h-5 w-5 text-emerald-400" />
              : <Target className={`h-5 w-5 ${colorClass}`} />
            }
            <span className="text-slate-300 font-medium">Monthly Customer Target</span>
          </div>
          <span className={`text-lg font-semibold ${colorClass}`} data-testid={`${testId}-count`}>
            {current} / {target}
          </span>
        </div>
        <Progress value={percent} className="h-3 bg-slate-800" />
        <div className="mt-2 flex items-center justify-between text-xs">
          <span className="text-slate-500">
            {complete
              ? 'Target achieved for this month'
              : `${(target - current)} more to go`}
          </span>
          <span className={`font-medium ${colorClass}`} data-testid={`${testId}-percent`}>
            {percentRaw.toFixed(0)}%
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
